'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRhumb = require('react-rhumb');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

var _statusComparators = require('conversations-async-data/async-data/operators/statusComparators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checker = function Checker(_ref) {
  var startOpen = _ref.startOpen,
      widgetDataAsyncData = _ref.widgetDataAsyncData,
      threadsAsyncData = _ref.threadsAsyncData;

  var requestsToCheck = [widgetDataAsyncData];

  if (startOpen) {
    requestsToCheck.push(threadsAsyncData);
  }

  var anyFailed = requestsToCheck.some(function (asyncData) {
    return (0, _statusComparators.isFailed)(asyncData);
  });
  var allSucceeded = requestsToCheck.every(function (asyncData) {
    return (0, _statusComparators.isSucceeded)(asyncData);
  });

  if (anyFailed) {
    return _react2.default.createElement(_reactRhumb.NavMarker, { name: 'VISITOR_ERROR' });
  } else if (allSucceeded) {
    return _react2.default.createElement(_reactRhumb.NavMarker, { name: 'VISITOR_SUCCESS' });
  } else {
    return null;
  }
};

Checker.propTypes = {
  startOpen: _react.PropTypes.bool,
  threadsAsyncData: (0, _RecordPropType2.default)('AsyncData').isRequired,
  widgetDataAsyncData: (0, _RecordPropType2.default)('AsyncData').isRequired
};

exports.default = Checker;
module.exports = exports['default'];